//
// C Context type
// I Type of handler's args
// A Type of the actions being returned
//
const assertHandlerNameIsUnique = (() => {
    const h = {};
    return (name) => {
        if (h[name]) {
            throw new Error(`Worker API handler name is not unique ${name}`);
        }
        h[name] = true;
    };
})();
export const makeActionCreator = ({ name, handle, }) => {
    assertHandlerNameIsUnique(name);
    const actionType = `actionHandler.${name}`;
    const actionCreator = (args) => ({
        type: actionType,
        payload: args,
        error: false,
    });
    actionCreator.handler = { actionType, handle };
    return actionCreator;
};
